module.exports = __webpack_public_path__ + "img/birdslife_bottomimage5.335b7d47.jpg";